import React, { useMemo } from "react";

export const Petals = React.memo(function Petals({ count = 12 }) {
  const petals = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        left: Math.random() * 100,
        duration: 9 + Math.random() * 12,
        delay: Math.random() * 12,
        scale: 0.5 + Math.random() * 1.1,
        opacity: 0.2 + Math.random() * 0.4,
      })),
    [count]
  );
  return (
    <div aria-hidden="true">
      {petals.map((p, i) => (
        <span
          key={i}
          className="petal"
          style={{
            left: `${p.left}%`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            transform: `scale(${p.scale})`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
});
